import React from 'react'
import { Carousel } from 'react-bootstrap'

import Ticket from '@components/Ticket'
import { IMetadataProperties } from '@types'

import {
    CustomCarousel,
    CustomCarouselContainer,
    CustomCarouselCounter,
    CustomCarouselCounterWrapper,
    SuccessNavItemTitleMain,
} from './styles'

interface IAssetCarouselProperties {
    setAssetIndex?: (assetIndex: number) => void
    metadataResults: IMetadataProperties[]
    owner: string
}

const AssetCarousel: React.FC<IAssetCarouselProperties> = ({ metadataResults, setAssetIndex, owner }) => {
    const [index, setIndex] = React.useState(0)

    const handleSelect = React.useCallback((selectedIndex: number) => {
        setIndex(selectedIndex)
    }, [])

    React.useEffect(() => {
        if (setAssetIndex) setAssetIndex(index)
    }, [index])

    return (
        <CustomCarouselContainer>
            <CustomCarousel
                activeIndex={index}
                onSelect={handleSelect}
                indicators={false}
                dont_show_arrow={metadataResults.length <= 1 ? 'true' : undefined}
            >
                {metadataResults.map((metadata, index) => (
                    <Carousel.Item key={`${index}-${metadata.name}`}>
                        <Ticket
                            assetId={metadata.id}
                            assetUrl={metadata.animation_url ? metadata.animation_url : metadata.image}
                        />
                    </Carousel.Item>
                ))}
            </CustomCarousel>
            <CustomCarouselCounterWrapper>
                <SuccessNavItemTitleMain>
                    <span id="meta-data-name">
                        {owner} {metadataResults[index]?.name}
                    </span>
                </SuccessNavItemTitleMain>
                <CustomCarouselCounter>{`${index + 1} / ${metadataResults.length}`}</CustomCarouselCounter>
            </CustomCarouselCounterWrapper>
        </CustomCarouselContainer>
    )
}

export default AssetCarousel
